import { useAuth0 } from '@auth0/auth0-react';
import { deleteAuthToken } from 'core/framework/localStorage';

const AuthZeroClient = () => {
  const { loginWithRedirect, isAuthenticated, user, isLoading, getAccessTokenSilently, logout } =
    useAuth0();

  const forceLogout = () => {
    deleteAuthToken();
    return logout({
      logoutParams: {
        returnTo: window.location.origin + '/login',
      },
    });
  };

  const signup = () => {
    loginWithRedirect({
      authorizationParams: {
        screen_hint: 'signup',
      },
    });
  };

  return {
    forceLogout,
    getAccessTokenSilently,
    isAuthenticated,
    isLoading,
    loginWithRedirect,
    logout,
    signup,
    user,
  };
};

export default AuthZeroClient;
